/** Standard API success response envelope */
export interface ApiResponse<T> {
    statusCode: number;
    data: T;
    meta?: PaginationMeta;
}

/** Pagination metadata for list endpoints */
export interface PaginationMeta {
    total: number;
    page: number;
    limit: number;
    totalPages?: number;
}

export type SortOrder = 'asc' | 'desc';

export interface DateRangeQuery {
    start_date: string;
    end_date: string;
}

export type CurrencyCode = 'INR' | 'AED' | 'SAR' | 'QAR' | 'OMR' | 'BHD' | 'KWD';

/** The complete, in-scope set of supported currencies — single source of truth. */
export const SUPPORTED_CURRENCIES: readonly CurrencyCode[] = [
    'INR',
    'AED',
    'SAR',
    'QAR',
    'OMR',
    'BHD',
    'KWD',
] as const;

/** Standard API error response */
export interface ApiError {
    statusCode: number;
    error: string;
    message: string;
    details?: FieldError[];
}

/** Field-level validation error */
export interface FieldError {
    field: string;
    message: string;
}

/** Health check response */
export interface HealthCheckResponse {
    status: 'ok' | 'error';
    uptime: number;
    checks: {
        database: 'ok' | 'error';
        redis: 'ok' | 'error';
        rabbitmq: 'ok' | 'error';
    };
}
